import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

let lenisInstance = null;
export const getLenis = () => lenisInstance;

export function SmoothScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); lenisInstance = null; };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.getElementById(hash.slice(1)) : null;
      if (el) {
        if (lenisInstance) lenisInstance.scrollTo(el, { offset: -90 });
        else el.scrollIntoView();
      } else if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, hash ? 120 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
